<template>
    <div>
        <div v-if="!componentIsLoading">
            <table class="table" v-if="expectedDocuments.length > 0">
                <thead>
                    <tr>
                        <th>Document</th>
                        <th>État</th>
                        <th></th>
                    </tr>
                </thead>
    
                <item v-for="(expectedDocument, idx) in expectedDocuments"
                    :key="'expected-document-' + idx"
                    :ref="'expectedDocument' + idx"
                    :index="idx"
                    :customer-id="customerId"
                    :expected-document="expectedDocument"
                    @expiration-date-updated="onExpirationDateUpdated($event)"
                    @file-uploaded="onFileUploaded($event)"
                    @file-deleted="onFileDeleted($event)"
                    @document-validated="onDocumentValidated($event)"
                    @document-refused="onDocumentRefused($event)"
                ></item>
            </table>
    
            <p v-else>Aucun document n'est attendu pour cette demande.</p>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
import {mapState, mapActions} from "vuex"
import Item from 'components/CustomerDocuments/Item'
import ComponentLoader from 'components/ComponentLoader'

export default {
    name:"DocumentsList",

    props: {
        customerId: {
            type: Number,
            required: true
        },
        validationRequestId: {
            type: Number,
            required: true
        }
    },
    
    data () {
        return {
            componentIsLoading : true,
        }
    },

    components: {
        Item,
        ComponentLoader
    },

    mounted() {
        this.fetchExpectedDocuments(this.validationRequestId)
            .then(() => this.componentIsLoading = false)
    },
    
    computed: {
        ...mapState('demands', {
            expectedDocuments: 'expected_documents'
        })
    },
    
    methods: {
        ...mapActions('demands', ['fetchExpectedDocuments']),

        getItemComponent(index) {
            return this.$refs['expectedDocument' + index][0]
        },
        
        getItemSummaryComponent(index) {
            return this.getItemComponent(index).$refs['itemSummary']
        },
        
        getItemDetailComponent(index) {
            return this.getItemComponent(index).$refs['itemDetail']
        },
        
        getPublishedVersionManagerComponent(index) {
            return this.getItemDetailComponent(index).$refs['publishedVersionManager']
        },
        
        getDraftVersionManagerComponent(index) {
            return this.getItemDetailComponent(index).$refs['draftVersionManager']
        },
        
        getArchivedVersionsManagerComponent(index) {
            return this.getItemDetailComponent(index).$refs['archivedVersionsManager']
        },

        onExpirationDateUpdated(index) {
            const publishedVersionManagerComponent = this.getPublishedVersionManagerComponent(index)

            this.fetchExpectedDocuments(this.validationRequestId)
                .then(() => {
                    publishedVersionManagerComponent.fetchCustomerDocument()
                        .then(() => {
                            // publishedVersionManagerComponent.$refs['expirationDateUpdateModal'].isLoading = false
                            publishedVersionManagerComponent.hideExpirationDateUpdateModal()
                        })
                })
        },
        onFileUploaded(index) {
            const draftVersionManagerComponent = this.getDraftVersionManagerComponent(index)

            this.fetchExpectedDocuments(this.validationRequestId)
                .then(() => {
                    draftVersionManagerComponent.fetchCustomerDocument()
                })
        },
        onFileDeleted(index) {
            const draftVersionManagerComponent = this.getDraftVersionManagerComponent(index)

            this.fetchExpectedDocuments(this.validationRequestId)
                .then(() => {
                    draftVersionManagerComponent.fetchCustomerDocument()
                        .then(() => {
                            // draftVersionManagerComponent.$refs['fileDeletionModal'].isLoading = false
                            draftVersionManagerComponent.hideFileDeletionModal()
                        })
                })
        },
        onDocumentValidated(index) {
            const draftVersionManagerComponent = this.getDraftVersionManagerComponent(index)

            this.fetchExpectedDocuments(this.validationRequestId)
                .then(() => {
                    draftVersionManagerComponent.fetchCustomerDocument()
                        .then(() => {
                            this.getArchivedVersionsManagerComponent(index).fetchArchivedVersions()
                                .then(() => {
                                    // draftVersionManagerComponent['documentValidationModal'].isLoading = false
                                    draftVersionManagerComponent.hideDocumentValidationModal()
                                })
                        })
                })
        },
        onDocumentRefused(index) {
            const draftVersionManagerComponent = this.getDraftVersionManagerComponent(index)

            this.fetchExpectedDocuments(this.validationRequestId)
                .then(() => {
                    draftVersionManagerComponent.fetchCustomerDocument()
                        .then(() => {
                            // draftVersionManagerComponent['documentRefusalModal'].isLoading = false
                            draftVersionManagerComponent.hideDocumentRefusalModal()
                        })
                })
        }
    },
    
    watch : {},
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// client/components/Demands/Documents/List.vue